import { getToday } from '../../../../handlers/helpers';
import { onSave, save } from '../../../../handlers';

class NotesUtils {

  constructor( stateProps, sectionName ) {
    this.stateProps = stateProps;
    this.sectionName = sectionName
    this.resumeIndex = stateProps.sectionData.resumeIndex;
    this.resume = stateProps.dataToSave.saved.resumes[this.resumeIndex];
    const section = stateProps.dataToSave.saved.resumes[this.resumeIndex][this.sectionName];
    if(section !== undefined) {
      if(section[0] === undefined)
        section[0] = {};
      this.notes = stateProps.dataToSave.saved.resumes[this.resumeIndex][this.sectionName][0]['notes'];
    }
  }
  open() {
    const sectionID = 'div[data-id=' + this.sectionName + '_notes]';
    const notesContainer = document.querySelector(sectionID);
    if (notesContainer.style.display === 'block') {
      notesContainer.style.display = 'none';
    } else {
      notesContainer.style.display = 'block';
    }
  }


  add() {
  const notesLength = this.notes === undefined ? 0 : this.notes.length;
    if (notesLength === 0) {
      this.notes = [];
    }
    const dateTime = getToday(true);
    const id = `note_${Date.now()}`;
    this.notes.push({ id: id, owner: 'C',date: dateTime, note: 'new note text' });

    this.commit();
  }
  toggle(e,id) {
    const note = document.querySelector(`#${id}`);
    const noteCloser = e.currentTarget;
    if(note) {
      if(note.style.display !== 'block') {
        note.style.display = 'block';
        noteCloser.innerText = '-'
      }      else {
        noteCloser.innerText = '+'
        note.style.display = 'none';
      }
    }
  }
  change(e,  field, noteOrder) {
    this.notes[noteOrder][field] = e.currentTarget.value;
    this.commit();
  }
  changeReply(e,field,noteOrder,replyOrder) {
    this.notes[noteOrder].replies[replyOrder][field] = e.currentTarget.value;
    this.commit();
  }
  clear(noteOrder) {
    const note = this.notes[noteOrder];
    if (note.cleared) {
      note.cleared = false;
    } else {
      note.cleared = true;
    }
  }

  delete(noteOrder) {
    this.notes.splice(noteOrder, 1);
    this.commit();
  }
  addReply(e,noteOrder,owner = 'C') {
    if(!this.stateProps.isAdmin) {
      const firstName = this.resume.contact[0].first || 'J';
      const lastName = this.resume.contact[0].last || 'S';
      owner = firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();

    }
    if(this.notes[noteOrder].replies === undefined) {
      this.notes[noteOrder].replies = [];
    }
    const dateTime = getToday(true);
    const id = `note_${Date.now()}`;
    this.notes[noteOrder].replies.push({ id:id, owner:owner,date: dateTime, note: 'new reply' });
    this.commit();
  }
  deleteReply(noteOrder,replyOrder) {
    this.notes[noteOrder].replies.splice(replyOrder, 1);
    this.commit();
  }
  commit() {
    const newData = this.stateProps.dataToSave.saved;
    newData.resumes[this.resumeIndex][this.sectionName][0].notes = this.notes;
    this.stateProps.setDataToSave({ saved: newData, industry: this.stateProps.dataToSave.industry });
    this.stateProps.isDataSaved(true);
    save(this.stateProps, this.resumeIndex);
  }
  save(e,formikProps) {
    onSave(e,formikProps,this.stateProps,this.resumeIndex);
  }
}

export default NotesUtils;